import { ComponentProps } from "react";

import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";

/* Sprite-backed: header banner tag, drawn twice (desktop and mobile); the path lives in `IconSprite`. */
export const IconThemeTagLabelFilled = (props: ComponentProps<"svg">) => (
  <SpriteIcon
    symbol={SPRITE_SYMBOLS.tagLabelFilled}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  />
);
